import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DashboardNumber from "./DashboardNumber";
import DashboardGraph from "./DashboardGraph";
import FeedbackDashboard from "./FeedbackDashboard";
import { doRequest } from "../utils/helper";
import Sidebar from "../components/Sidebar";
import AdminFooter from "../components/AdminFooter";
import FinanceInfo from "./FinanceInfo";
import moment from "moment";

export default function AdminDashboard() {
  const [startDate, setStartDate] = useState(new Date());
  const [userData, setUserData] = useState([]);
  const [endtDate, setEndDate] = useState(new Date());
  const [financeStartDate, setFinanceStartDate] = useState(new Date());
  const [financeEndtDate, setFinanceEndDate] = useState(new Date());
  const [feedbackList, setFeedbackList] = useState([]);
  const [financeData, setFinanceData] = useState([]);
  const [selectedDuration, setSelectedduration] = useState("");

  const selectStyle = {
    // background: `url("/asset/images/arrowselect.svg") no-repeat`,
    // backgroundSize: "24px 24px",
    // backgroundPosition: "96% 50%",
    outline: "none",
    appearance: "none", // For Chrome
    WebkitAppearance: "none", // For Safari
    MozAppearance: "none", // For Firefox
    paddingRight: "30px",
    color: "#08131f",
    width: "147px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
    border: "1px solid #d4e1f3",
    height: "36px",
    padding: "0px 10px",
    borderRadius: "4px",
  };

  const ExampleCustomInput = ({ value, onClick }) => (
    <button block className="admindate" onClick={onClick}>
      <span className="btn-wrapper--label">{value}</span>
      <span className="btn-wrapper--icon">
        <img src={"/assets/images/chevrondown.svg"} alt="" />
      </span>
    </button>
  );

  const ExampleCustomInput2 = ({ value, onClick }) => (
    <button block className="admindate" onClick={onClick}>
      <span className="btn-wrapper--label">{value}</span>
      <span className="btn-wrapper--icon">
        <img src={"/assets/images/chevrondown.svg"} alt="" />
      </span>
    </button>
  );

  const dashboardApi = async () => {
    try {
      const res = await doRequest("", "GET", "user/dashboard");
      if (+res?.resultFlag === 1) {
        setUserData(res.response?.data);
      } else {
        setUserData([]);
      }
    } catch (error) {}
  };

  const feedbackListApi = async () => {
    try {
      const res = await doRequest("", "GET", "feedback/list");
      if (+res?.resultFlag === 1) {
        setFeedbackList(res.response?.feedback);
      } else {
        setFeedbackList([]);
      }
    } catch (error) {}
  };

  const getFinanceData = async () => {
    let data = {};
    try {
      data = {
        fromDate: moment(financeStartDate).format("YYYY-MM-DD"),
        toDate: moment(financeEndtDate).format("YYYY-MM-DD"),
      };
      const url = `user/finance-dashboard?fromDate=${data.fromDate}&toDate=${data.toDate}`;
      const response = await doRequest("", "GET", url);
      if (+response?.resultFlag === 1) {
        setFinanceData(response?.response?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    dashboardApi();
    feedbackListApi();
  }, []);

  const setFinance = (value) => {
    if (value === "three_month") {
      const end = new Date();
      let start = new Date();
      start.setMonth(start.getMonth() - 3);
      setFinanceStartDate(start);
      setFinanceEndDate(end);
    } else if (value === "four_month") {
      const end = new Date();
      let start = new Date();
      start.setMonth(start.getMonth() - 4);
      setFinanceStartDate(start);
      setFinanceEndDate(end);
    } else if (value === "six_month") {
      const end = new Date();
      let start = new Date();
      start.setMonth(start.getMonth() - 6);
      setFinanceStartDate(start);
      setFinanceEndDate(end);
    } else if (value === "nine_month") {
      const end = new Date();
      let start = new Date();
      start.setMonth(start.getMonth() - 9);
      setFinanceStartDate(start);
      setFinanceEndDate(end);
    } else if (value === "twelve_month") {
      const end = new Date();
      let start = new Date();
      start.setMonth(start.getMonth() - 12);
      setFinanceStartDate(start);
      setFinanceEndDate(end);
    }
  };

  useEffect(() => {
    getFinanceData();
  }, [financeStartDate, financeEndtDate]);

  return (
    <>
      <div className="container-fluid main">
        <Sidebar />
        <section className="home">
          <div className="container-fluid">
            <div className="admin_pad">
              <div className="row">
                <div className="col-sm-6">
                  <h5 className="admin_head">Admin Dashboard</h5>
                </div>

                <div className="col-sm-6">
                  <ul className="frodate_list">
                    <li className="form_pad">
                      <h6>From</h6>
                    </li>
                    <li>
                      <div className="datepicker_analytics">
                        <DatePicker
                          className="form-control"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          customInput={<ExampleCustomInput />}
                          dateFormat="MMM YYYY"
                        />
                      </div>
                    </li>

                    <li className="form_pad">
                      <h6>To</h6>
                    </li>

                    <li>
                      <div className="datepicker_analytics">
                        <DatePicker
                          className="form-control"
                          selected={endtDate}
                          onChange={(date) => setEndDate(date)}
                          customInput={<ExampleCustomInput2 />}
                          dateFormat="MMM YYYY"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <DashboardNumber userData={userData} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h5 className="admin_head">Finance</h5>
                </div>

                <div className="col-sm-6">
                  <ul className="frodate_list">
                    <li className="form_pad">
                      <h6>From</h6>
                    </li>
                    <li>
                      <div className="datepicker_analytics">
                        <DatePicker
                          className="form-control"
                          selected={financeStartDate}
                          onChange={(date) => {
                            setFinanceStartDate(date);
                            setSelectedduration("");
                          }}
                          customInput={<ExampleCustomInput />}
                          dateFormat="MMMM YYYY"
                        />
                      </div>
                    </li>

                    <li className="form_pad">
                      <h6>To</h6>
                    </li>

                    <li>
                      <div className="datepicker_analytics">
                        <DatePicker
                          className="form-control"
                          selected={financeEndtDate}
                          onChange={(date) => {
                            setFinanceEndDate(date);
                            setSelectedduration("");
                          }}
                          customInput={<ExampleCustomInput2 />}
                          dateFormat="MMMM YYYY"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="datepicker_analytics"
                        style={{ marginLeft: "10px" }}
                      >
                        <select
                          style={selectStyle}
                          value={selectedDuration}
                          onChange={(e) => {
                            setSelectedduration(e.target.value);
                            setFinance(e.target.value);
                          }}
                          className="newselect cursor"
                        >
                          <option value="">Select Duration</option>
                          <option value="three_month">Last 3 Months</option>
                          <option value="four_month">Last 4 Months</option>
                          <option value="six_month">Last 6 Months</option>
                          <option value="nine_month">Last 9 Months</option>
                          <option value="twelve_month">Last 12 Months</option>
                        </select>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <FinanceInfo financeData={financeData} />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <DashboardGraph />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <FeedbackDashboard feedbackList={feedbackList} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AdminFooter />
    </>
  );
}
